import React, { useEffect, useMemo, useRef, useState } from "react";
import axios from "axios";
import { Modal, Button, Spinner } from "react-bootstrap";
import { useParams, useLocation } from "react-router-dom";
import Select from "react-select"; // react-select default export
import AsyncSelect from "react-select/async";
import Url from "app/shared/constants/Url";
import FetchEMList from "./services/fetchEMList";
import { ErrorToast, SuccessToast } from "../Popups/ToastMessage";
import { useHistory } from "react-router-dom";

const PollDetailsModal = ({ show = true, onClose }) => {
  const { poll_id } = useParams();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token");

  const [pollData, setPollData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  // selection & employee
  const [selectedOption, setSelectedOption] = useState(null); // object or null
  const [optionError, setOptionError] = useState(false);

  const [userName, setUserName] = useState("");
  const [employeeId, setEmployeeId] = useState("");
  const [form, setForm] = useState({ searchEmployeeUsers: null });
  const history = useHistory();

  const timeoutRef = useRef(null);

  useEffect(() => {
    if (!poll_id) return;
    fetchPoll();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [poll_id]);

  const fetchPoll = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await axios.get(Url.polling.getExternalPollingById, {
        params: { pollid: poll_id },
      });

      if (response?.data?.status === 200) {
        setPollData(response.data.data);
      } else {
        console.error("Unexpected response", response);
        ErrorToast(response?.data?.msg || "Failed to load poll");
      }
    } catch (err) {
      console.error("Error fetching poll:", err);
      if (err.response.status === 400) {
      setError(err.response?.data?.msg || err.message || "Failed to fetch poll");
      }
      else ErrorToast(err.response.data.msg ||"Failed to fetch poll");
    } finally {
      setLoading(false);
    }
  };

  // map to react-select format (memoized)
  const formattedOptions = useMemo(() => {
    if (!pollData || !Array.isArray(pollData.optionList)) return [];
    return pollData.optionList.map((opt) => ({
      value: opt.pollOptionId,
      label: opt.option,
    }));
  }, [pollData]);

  // async search for employee
  const searchClientEmployee = async (inputString) => {
    try {
      const response = await FetchEMList({ search: inputString });
      if (response.status === 200) {
        return response.data?.map((element) => ({
          ...element,
          label: element.displayName,
          value: element.clientEmployeeId,
        }));
      }
      return [];
    } catch (err) {
      return [];
    }
  };

  // submit handler
  const handleSave = async () => {
    // validation: option
    if (!selectedOption) {
      setOptionError(true);
      return;
    }

    // determine employee fields (prefer selected employee)
    const selectedEmployee = form.searchEmployeeUsers;
    const finalEmployeeId = selectedEmployee?.value || employeeId;
    const finalEmployeeName = selectedEmployee?.label || userName;

    // if (pollData.allowExternal== 1 && !userName?.trim()) {
    //   ErrorToast("Enter user name");
    //   return;
    // }

    if (!token) {
      ErrorToast("Invalid visitor token");
      return;
    }

    try {
      const fd = new FormData();
      fd.append("visitor_token", token);
      fd.append("poll_id", poll_id);
      fd.append("poll_option_id", selectedOption.value);
      fd.append("external_user_name", finalEmployeeName);
      fd.append("employee_id", finalEmployeeId);

      const res = await axios.post(Url.polling.submitExternalPollResponse, fd, {
        headers: {
          Origin: "qaclide",
        },
      });

      if (res?.data?.status === 200) {
        SuccessToast("Response submitted successfully ✅");
        onClose && onClose();
        history.push("/thankyou/externalpage");

      } else {
        ErrorToast(res?.data?.msg || "Submission failed");
      }
    } catch (error) {
      console.error("Submit error:", error);
    const backendMsg =
      error.response?.data?.msg || error.message || "Error submitting response";

    ErrorToast(backendMsg);    }
  };

  return (
    <Modal show={show} onHide={onClose} centered size="lg">
      <Modal.Header style={{ color: "#fff", borderBottom: "none"}}>
        <Modal.Title style={{ fontWeight: 600, color: "#fff" }}>
          {pollData?.pollName || "Poll"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body style={{ padding: 24 }}>
        {loading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) 
        : error ? (
          <div className="text-center text-muted">{error}</div>
        )
        : !pollData ? (
          <div className="text-center text-muted">No poll data available</div>
        ) : (
          <>
                 {pollData.pic && (
                    <div
                      style={{
                        margin: "0 auto 24px auto",
                        maxWidth: 520,
                        borderRadius: 12,
                        overflow: "hidden",
                        background: "#f8f9fa",
                        boxShadow: "0 6px 18px rgba(0,0,0,0.08)",
                        padding: 10,
                        textAlign: "center",
                      }}
                    >
                      <div
                        style={{
                          fontSize: 14,
                          fontWeight: 600,
                          marginBottom: 8,
                          color: "#555",
                        }}
                      >
                        Media
                      </div>

                      {pollData.pic.match(/\.(mp4|webm|ogg)$/i) ? (
                        <video
                          controls
                          style={{
                            width: "100%",
                            maxHeight: 320,
                            borderRadius: 8,
                            objectFit: "contain",
                            background: "#000",
                          }}
                        >
                          <source src={pollData.pic} />
                          Your browser does not support the video tag.
                        </video>
                      ) : (
                        <img
                          src={pollData.pic}
                          alt="poll media"
                          style={{
                            width: "100%",
                            maxHeight: 320,
                            borderRadius: 8,
                            objectFit: "contain",
                          }}
                        />
                      )}
                    </div>
                  )}
            <DetailRow label="Description" value={pollData.description} />
            <DetailRow label="Category" value={pollData.category_name} />
            <DetailRow label="Status" value={pollData.status} />
            <DetailRow label="Start Date" value={`${pollData.startDate} ${pollData.startTime}`} />
            <DetailRow label="End Date" value={`${pollData.endDate} ${pollData.endTime}`} />

            {/* <DetailRow
              label="Image"
              value={<img src={pollData.pic} alt="poll" style={{ width: 180, borderRadius: 4 }} />}
            /> */}
                  {/* {pollData.pic && (
                    <DetailRow
                      label="Media"
                      value={
                        pollData.pic.match(/\.(mp4|webm|ogg)$/i) ? (
                          <video
                            controls
                            style={{
                              width: "100%",
                              maxWidth: 320,
                              borderRadius: 8,
                              background: "#000"
                            }}
                          >
                            <source src={pollData.pic} />
                            Your browser does not support the video tag.
                          </video>
                        ) : (
                          <img
                            src={pollData.pic}
                            alt="poll media"
                            style={{
                              width: "100%",
                              maxWidth: 320,
                              borderRadius: 8,
                              objectFit: "cover"
                            }}
                          />
                        )
                      }
                    />
                  )} */}

            <DetailRow label="Question" value={pollData.question} />

            {/* OPTIONS - react-select */}
            <div className="mb-3">
              <label style={{ fontWeight: 500 }}>
                Select Option <span style={{ color: "red" }}>*</span>
              </label>

              <Select
                options={formattedOptions}
                value={selectedOption}
                onChange={(selected) => {
                  setSelectedOption(selected);
                  setOptionError(false);
                }}
                placeholder="Select Option"
                isClearable
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                styles={{
                  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                }}
              />
              {optionError && (
                <div style={{ color: "red", fontSize: 12, marginTop: 6 }}>Please select an option</div>
              )}
            </div>

            {/* Employee search (async) */}
            {!!pollData.allowEmployee &&  (<div className="mb-3">
              <label className="form-label">Search Employee</label>
              <AsyncSelect
                cacheOptions
                defaultOptions
                value={form.searchEmployeeUsers || null}
                placeholder="Search Employee"
                loadOptions={(inputValue) =>
                  new Promise((resolve) => {
                    if (timeoutRef.current) clearTimeout(timeoutRef.current);
                    timeoutRef.current = setTimeout(async () => {
                      if (!inputValue) {
                        resolve([]);
                        return;
                      }
                      const results = await searchClientEmployee(inputValue);
                      resolve(results);
                    }, 400);
                  })
                }
                onChange={(selected) => {
                  setForm((prev) => ({ ...prev, searchEmployeeUsers: selected }));
                  // populate quick fields for submission convenience
                  setEmployeeId(selected?.value || "");
                  setUserName("");
                }}
                menuPortalTarget={typeof document !== "undefined" ? document.body : null}
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </div>)}
            <label className="form-label">
                      {/* User Name {pollData.allowExternal === 0 ? "(optional)" : <span style={{ color: "red" }}>*</span>} */}
                      User Name
                    </label>
            {/* fallback manual entry (if external user) */}
            <div className="mb-3">
             <input
                type="text"
                className="form-control"
                value={userName}
                onChange={(e) => {setUserName(e.target.value)
                  setForm((prev) => ({ ...prev, searchEmployeeUsers: null }))
                  setEmployeeId("") 
                }}
                placeholder="Enter name"
              />
            </div>

          </>
        )}
      </Modal.Body>

      <Modal.Footer style={{ borderTop: "none", padding: "16px 24px" }}>
      { !error && <Button
          style={{
            backgroundColor: "#ff5a3c",
            borderColor: "#ff5a3c",
            borderRadius: 8,
            padding: "6px 22px",
            fontWeight: 500,
          }}
          onClick={handleSave}
        >
          Submit
        </Button>}
      </Modal.Footer>
    </Modal>
  );
};

/* Reusable Row */
const DetailRow = ({ label, value }) => (
  <div
    style={{
      display: "grid",
      gridTemplateColumns: "140px 10px 1fr",
      marginBottom: 14,
      alignItems: "start",
    }}
  >
    <div style={{ color: "#777" }}>{label}</div>
    <div style={{ color: "#999" }}>|</div>
    <div style={{ fontWeight: 500 }}>{value}</div>
  </div>
);

export default PollDetailsModal;